module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_6000.e92e0e71.png";